export default{
    init(){
        this.saveAudience();
        this.saveCampaign();
        this.saveTemplate();
        this.initActionForRow();
        this.uploadFileListner();
        this.campaignActions();
        this.additionalModalWindow();
        this.paginationOnPage();
        this.removeScheduleDate();
    },

    saveAudience(){
        $('#admin-save-audience').click(() => {
            if (this.validateForm('audience')) {
                let data = {
                    id: $('#audience_id').val(),
                    name: $('#audience_name').val(),
                    template_id: $('#template_id').val(),
                    campaign_id: $('#campaign_id').val(),
                    customers: JSON.stringify(this.collectCustomersForAudience()),
                };
                $.ajax({
                    method: 'POST',
                    url: '/admin/email-marketing/save-campaign-audience',
                    data: data,
                    success: (response,textStatus, jqXHR) => {
                        console.log(response,textStatus, jqXHR.status);
                        if ( jqXHR.status == 200) {
                            location.href = response.redirect_url;
                        }
                    },
                    error: (response) => {
                        console.log(response);
                    }
                });
            }
        });
    },
    saveTemplate(){
        $('#save_admin_campaign_email').click(function() {
            $('.bb-preloader-container').show();
            let data = {
                title: $('#email_title').val(),
                subject: $('#email_subject').val(),
                headline: $('#email_headline').val(),
                customer_greeting: $('#email_customer_name').val(),
                top_content: $('#email_top_content').val(),
                center_image_link:  $('#activate_center_image').is(':checked')==true ? $('#path_img').val() : '',
                bottom_content: $('#email_bottom_content').val(),
                template_id: $('#template_id').val(),
                campaign_id: $('#campaign_id').val(),
                audience_id: $('#audience_id').val(),
            };
            $.ajax({
                type: 'POST',
                url: '/admin/email-marketing/save-campaign-email-template',
                data: data,
                success: (response) => {
                    $('.bb-preloader-container').hide();
                    location.href = response.redirect_url;
                },
                error: (response) => {
                    $('.bb-preloader-container').hide();
                }
            });
        })
    },
    saveCampaign(){
        $('.save-campaign').click(() => {
            const url = '/admin/email-marketing/save-email-campaign';
            let data = {
                audience_id: $('#audience_id').val(),
                template_id: $('#template_id').val(),
                schedule_date: $('#campaign_schedule_date').val(),
                campaign_id: $('#campaign_id').val(),
            };
            this.sendCampaign(url, data);
        });
        $('.break-creating-campaign').click(function () {
            location.href = '/admin/email-marketing';
        });
    },

    sendCampaign(url, data){
        $('.bb-preloader-container').show()
        $.ajax({
            method: 'POST',
            url: url,
            data: data,
            success: (response) => {
                location.href = response.redirect_url;
            },
            error: (response) => {
                $('.bb-preloader-container').hide();
                console.log(response.responseJSON.errors);
                if (response.responseJSON.errors) {
                    let errors = Object.values(response.responseJSON.errors);
                    $('.errors').find('p').remove();
                    errors.forEach(element => {
                        //console.log(element);
                        $('.errors').append(`<p>${element}</p>`)
                    });
                    let errors_keys = Object.keys(response.responseJSON.errors);
                    errors_keys.forEach(element => {
                        console.log(element);
                        if (element == 'audience_id') {
                            $('.admin_create_audience').addClass('warning-animation')
                            setTimeout(() => {
                                $('.admin_create_audience').removeClass('warning-animation')
                            }, 2000);
                        }else if(element == 'template_id'){
                            $('.admin_create_template').addClass('warning-animation')
                            setTimeout(() => {
                                $('.admin_create_template').removeClass('warning-animation')
                            }, 2000);
                        }
                    });
                }
            }
        });
    },

    validateForm(formType){
        let flag = true;
        if (formType == 'audience') {
            if ($('#audience_name').val() == '') {
                $('#audience_name').css('border', '2px solid red');
                flag = false;
            }
        }else if(formType == 'template'){

        }else{

        }
        return flag;
    },

    collectCustomersForAudience(){
        let customers = [];
        let table = $('.audience_table tbody').find('tr').toArray();
        table.forEach(element => {
            customers.push({
                name: $(element).find('.name').text(),
                email: $(element).find('.email').text(),
            })
        });
        return customers;
    },

    initActionForRow(){
        $('body').on('click','.delete_row',function() {
            $(this).parents('tr').remove();
        });
        $('body').on('click','.edit_row',function() {
            let row = $(this).parents('tr');

            $('#recipient_modal #recipient_name').val(row.find('.name').text());
            $('#recipient_modal #recipient_email').val(row.find('.email').text());
            $('#recipient_modal').modal('show');
            $('#recipient_modal #add_recipient_btn').text('Edit');
            $('#recipient_modal #add_recipient_btn').data('action', 'edit');
            $('#recipient_modal #add_recipient_btn').data('row', row);
        });
        $('.add_recipient').click(function() {
            $('#recipient_modal #recipient_name').val();
            $('#recipient_modal #recipient_email').val();
            $('#recipient_modal #add_recipient_btn').text('Add');
            $('#recipient_modal #add_recipient_btn').data('action', 'add');
            $('#recipient_modal').modal('show');
        });
        $('body').on('click', '#recipient_modal #add_recipient_btn', function() {
            if ($(this).data('action') == 'add') {
                let name = $('#recipient_modal #recipient_name').val();
                let email = $('#recipient_modal #recipient_email').val();
                $('.audience_table tbody').append('<tr>'+
                `<td class="name">${name}</td><td class="email">${email}</td><td>--</td>`+
                '<td>'+
                '<a href="#" class="text-underline fw-500 text-primary mx-2 edit_row">Edit</a>'+
                '<a href="#" class="text-underline fw-500 text-primary mx-2 delete_row">Delete</a>'+
                '</td>');
            }else{
                let row = $(this).data('row');
                console.log(row);
                row.find('.name').text($('#recipient_modal #recipient_name').val());
                row.find('.email').text($('#recipient_modal #recipient_email').val());
            }
            $('#recipient_modal').modal('hide');
        });
        $('.upload_csv_btn').click(function() {
            $('#open_file').val('');
            $('#open_file').click();
        });

    },
    /**
     * Активности на странице создания постовой рассылки
     */
    campaignActions(){
        $('body').on('click','.select_exist_audience',() => {
            const type = 'add_exists_audience';
            this.callModal({type: type}, type)
        });
        $('body').on('click','.select_exist_template',() => {
            const type = 'add_exists_templates';
            this.callModal({type: type}, type)
        });
        $('body').on('click','.edit-campaign-template', function() {
            const template = $('#template_id').val() !=='' ? $('#template_id').val() : $(this).data('template_id');
            const audience = $('#audience_id').val();
            const campaign = $('#campaign_id').val();
            location.href = `/admin/email-marketing/campaign-email-template?campaign_id=${campaign}&template_id=${template}&audience_id=${audience}`;
        });
        $('body').on('click', '.edit-campaign-audience', function() {
            const template = $('#template_id').val();
            const audience = $('#audience_id').val() !== '' ? $('#audience_id').val() : $(this).data('audience_id');
            const campaign = $('#campaign_id').val();
            location.href = `/admin/email-marketing/campaign-audience?campaign_id=${campaign}&template_id=${template}&audience_id=${audience}`;
        });
        $('body').on('click', '.show-recipients', (e) => {
            const type = "show-recipients";
            this.callModal({
                type: type,
                audience_id: $(e.target).data('audience_id'),
            }, type);
        });
        $('body').on('click','.admin_delete_audience', ()=>{
            const template_id = $('#template_id').val();
            $('#audience_id').val('')
            $.ajax({
                type: 'POST',
                url: '/admin/email-marketing/get-audience-info',
                data: {
                    template_id: template_id,
                },
                success: (response) => {
                    $('.create-audience-container').html(response);
                    $('#add_exists_audience').modal('hide');
                    this.checkStepsCampaign();
                }
            });
        });
        $('body').on('click','.admin_delete_template', ()=>{
            const audience_id = $('#audience_id').val();
            $('#template_id').val('');
            $.ajax({
                type: 'POST',
                url: '/admin/email-marketing/get-template-info',
                data: {
                    audience_id: audience_id,
                },
                success: (response) => {
                    $('.create-template-container').html(response);
                    $('#add_exists_templates').modal('hide');
                    this.checkStepsCampaign();
                }
            });
        });
        $('.admin_schedule_campaign').click(function() {
            $('#schedule_campaign_modal').modal('show');
        });
        $('#schedule_dt_btn').click(function() {
            if ($('#campaign_id').val() == '') {
                $('.save-campaign').text('Create Campaign');
            } else {
                $('.save-campaign').text('Update Campaign');
            }
        });
        $('.admin_send_now_campaign').click(function() {
            $('#send_now_confirmation_modal').modal('show');
        });
        $('.admin_send_now_btn').click(() => {
            const url = '/admin/email-marketing/save-email-campaign';
            let data = {
                audience_id: $('#audience_id').val(),
                template_id: $('#template_id').val(),
                schedule_date: 'now',
                campaign_id: $('#campaign_id').val(),
            };
            this.sendCampaign(url, data);
        });

        $('body').on('click','.admin_create_template, .admin_create_audience',(e)=> {
            e.preventDefault();
            let endpoint = '';
            if ($(e.target).hasClass('admin_create_template')) {
                endpoint = 'campaign-email-template';
            }else{
                endpoint = 'campaign-audience';
            }
            const url = `/admin/email-marketing/${endpoint}`;
            const audience_id = $('#audience_id').val();
            const campaign_id = $('#campaign_id').val();
            const template_id = $('#template_id').val();
            this.redirectTo(url, {
                audience_id: audience_id,
                campaign_id: campaign_id,
                template_id: template_id
            });
        });
    },

    redirectTo(url, params={}){
        let params_str = '';
        for (const key in params) {
            if (params_str == '') {
                params_str = '?';
            }else{
                params_str += '&';
            }
            if (Object.hasOwnProperty.call(params, key)) {
                const element = params[key];
                params_str+=`${key}=${element}`;
            }
        }
        location.href = url+params_str;
    },
    uploadFileListner(){
        $('#open_file').on('change', function() {
            if ($(this).val().length) {
                var fileDataArray = [];
                $(this)[0].files[0].text().then((text) => { //промис на проверку количества строк в файле.
                    let row_count = text.split('\n').length;
                    let warn_text = 'Loading...';
                    if (row_count > 10002) {
                        $('#csv-warning-modal .modal-title').text('Error')
                        $('#csv-warning-modal .warning-text').text('Your file is too large, please split it into smaller CSV files of up to 10000 customers and reupload each separately')
                        $('#csv-warning-modal').modal('show');
                        return Promise.reject('Your file is too large, please split it into smaller CSV files of up to 10000 customers and reupload each separately');
                    } else if (row_count > 2000) {
                        $('#csv-warning-modal').modal('show');
                        warn_text = 'Uploading a very large file, this may take a few minutes. Please wait...';
                    }
                    return warn_text;
                }).then((result) => {
                    var fd = new FormData();
                    fd.append('csvFile', $(this)[0].files[0])
                    console.log($(this)[0].files[0]);
                    $.ajax({
                        type: 'POST',
                        url: '/admin/email-marketing/upload-customers',
                        data: fd,
                        processData: false,
                        contentType: false,
                        beforeSend: function () {
                            if ($('table tbody tr.success').length > 0) $('table tbody tr.loading').remove();
                            $('table tbody').append(`<tr class="loading text-center p4"><td colspan="8">${result}</td></tr>`);
                            if (result.indexOf('Loading') < 0) {
                                setTimeout(() => {
                                    $('#csv-warning-modal').modal('hide')
                                    $('.bb-preloader-container').show()
                                }, 1000)
                            } else {
                                $('.bb-preloader-container').show()
                            }
                        },
                        success: (response) => {
                       //     console.log(response)
                            if (response.success) {
                                $('table tbody tr.loading').remove();
                                $('#inputFileName').val(response.fileName);
                                fileDataArray = [...response.fileData];
                                fileDataArray.forEach((element, index, array) => {
                                    const isNew = (element.isNew == 'new') ? 'style="color:#DB3A57"' : '';
                                    const emailLink = '<a class="font-weight-bold add-csv-data" data-email="0" style="color:#DB3A57">add</a>'
                                    const phoneLink = '<a class="font-weight-bold add-csv-data" data-phone="0" style="color:#DB3A57">add</a>'
                                    const addressLink = '<a class="font-weight-bold add-csv-data" data-address="0" style="color:#DB3A57">add</a>'
                                    const zipcodeLink = '<a class="font-weight-bold add-csv-data" data-zip_code="0" style="color:#DB3A57">add</a>'

                                    $('table tbody').append(`
                                        <tr>`+
                                            `<td class="name">${element.first_name} ${element.last_name}</td>
                                            <td class="email">${(typeof (element.email) !== 'undefined' && element.email) ? element.email : emailLink}</td>
                                            <td>--</td>
                                            <td>
                                                <a href="#" class="text-underline fw-500 text-primary mx-2 edit_row">Edit</a>
                                                <a href="#" class="text-underline fw-500 text-primary mx-2 delete_row">Delete</a>
                                            </td>
                                        </tr>`
                                    );
                                });

                                $('.height-wrapper a').removeClass('d-none');
                                $('.left-side-button button').removeClass('btn-primary').addClass('btn-inactive text-white').attr('disabled', true);
                                $('.right-side-button button').removeClass('btn-inactive');

                                $('.bb-preloader-container').hide();
                            }

                        if (!response.success) {
                            $('.bb-preloader-container').hide();
                            $('table tbody tr.loading').remove();
                            $('#response-upload-modal').modal('show');
                            $('#response-upload-modal .form-validation-errors').text(response.message)
                        }

                        },
                        error: (error) => {
                            $('.bb-preloader-container').hide();
                            $('.csv-table tbody').remove();
                            $('.csv-table').append(`<tbody></tbody>`);
                         //   console.log(error)
                        },
                        complete: function () {
                            $('.bb-preloader-container').hide();
                        }
                    });
                }, (result) => {
                    $('.bb-preloader-container').hide();
                    //  console.error(result);
                });
            }
        })
    },

    selectExistAudienceAndTemplateListners(parentForm){
        $('.select-exist-audience-btn').click((e) => {
            const audience_id = $(e.target).data('audience_id');
            const template_id = $('#template_id').val();
            $.ajax({
                type: 'POST',
                url: '/admin/email-marketing/get-audience-info',
                data: {
                    audience_id: audience_id,
                    template_id: template_id,
                },
                success: (response) => {
                    $('#audience_id').val(audience_id);
                    $('.create-audience-container').html(response);
                    $(parentForm).modal('hide');
                    this.checkStepsCampaign();
                }
            });
        });
        $('.select-exist-template-btn').click((e) => {
            const audience_id = $('#audience_id').val();
            const template_id = $(e.target).data('template_id');
            $.ajax({
                type: 'POST',
                url: '/admin/email-marketing/get-template-info',
                data: {
                    audience_id: audience_id,
                    template_id: template_id,
                },
                success: (response) => {
                    $('#template_id').val(template_id);
                    $('.create-template-container').html(response);
                    $(parentForm).modal('hide');
                    this.checkStepsCampaign();
                }
            });
        });
    },

    callModal(data, type){
        $('.bb-preloader-container').show();
        $.ajax({
            type: 'POST',
            url: '/admin/email-marketing/modal',
            data: data,
            success: (response)=>{
                $('.bb-preloader-container').hide();
                $('#form-container').html(response);
                $(`#${type}`).modal('show');
                this.selectExistAudienceAndTemplateListners(`#${type}`);
            },
            error: (response)=>{
                $('.bb-preloader-container').hide();
            }
        });
    },

    additionalModalWindow(){
        $('.additional').click(function() {
            if ($(`.modal-window-actions.admin-email-campaigns`).hasClass('d-none')) {
                $(`.modal-window-actions.admin-email-campaigns`).removeClass('d-none');
                const parent = $(this).parents('tr');
                const audience_id = $(parent).data('audience_id');
                const campaign_id = $(parent).data('campaign_id');
                const template_id = $(parent).data('template_id');
                $(`.modal-window-actions.admin-email-campaigns`).find('.edit').attr('href', `/admin/email-marketing/email-campaign?campaign_id=${campaign_id}&audience_id=${audience_id}&template_id=${template_id}`);
                $(`.modal-window-actions.admin-email-campaigns`).find('.view').data('template_id', template_id);
                $(`.modal-window-actions.admin-email-campaigns`).find('.statistics').data('campaign_id', campaign_id);
            } else {
                $(`.modal-window-actions.admin-email-campaigns`).addClass('d-none');
            }
            let posX = $(this).offset().left - 120; //120
            let posY = $(this).offset().top + 12;
            $(`.modal-window-actions.admin-email-campaigns`).css({left: posX, top: posY});
        });
        $('body').on('click', '.modal-window-actions.admin-email-campaigns .action.view, #add_exists_templates .preview-template',function() {
            $('.bb-preloader-container').show();
            const template_id = $(this).data('template_id');
            console.log(template_id);
            if (template_id) {
                $('#preview-template-modal').modal('show');
                $('#preview-template-modal').find('iframe').attr('src', `/email-department/get-email?type=admin_campaign_email&template_id=${template_id}`)
            }

        })

        $('#preview-template-modal #preview_template').on('load', function () {
            console.log( $(this));
            setTimeout(
                function() {
                    $('#preview_template').height(window.frames.preview_template.document.body.children[0].offsetHeight);
                    $('.bb-preloader-container').hide();
                }, 200
            );
        })
        $('.modal-window-actions.admin-email-campaigns').on('click', '.statistics', (e) => {
            let type = 'email_sending_progress-modal';
            let data = {
                id: $(e.target).data('campaign_id'),
                type: type,
            };
            this.callModal(data, type);
        })
    },

    paginationOnPage(){
        $('.change-page-number').click(function() {
            let page = parseInt($('#page_number').val());
            if ($(this).hasClass('previous')) {
                page -=1;
            }else if($(this).hasClass('next')){
                page +=1;
            }else{
                return;
            }
            let search_string = `page=${page}`;
            window.location.search = search_string;
        });
    },

    removeScheduleDate(){
        $('.remove_date_launched').click(() => {
            const campaign_id = $('#campaign_id').val();
            const data = {
                campaign_id: campaign_id,
            };
            const url = '/admin/email-marketing/remove-schedule-date';
            this.sendCampaign(url, data);
        });
    },

    checkStepsCampaign(){
        const audience = $('#audience_id').val();
        const template = $('#template_id').val();
        if (audience>0 && template>0) {
            $('.save-campaign').removeAttr('disabled');
        }else{
            $('.save-campaign').attr('disabled', 'disabled');
        }
    }
}
